const module = 'APP_RES_'

export const SET_USERS = module + 'SET_USERS'
export const SET_DASHBOARD_FILTER = module + 'SET_DASHBOARD_FILTER'
export const SET_DASHBOARD_TARGET_FILTER = module + 'SET_DASHBOARD_TARGET_FILTER'
export const SET_DATASETS = module + 'SET_DATASETS'
export const SET_PRIMARY_INSIGHTS_FILTER = module + 'SET_PRIMARY_INSIGHTS_FILTER'
export const SET_BYOD_DATASET = module + 'SET_BYOD_DATASET'
export const SET_DATASET_FAMILIES = module + 'SET_DATASET_FAMILIES'
export const SET_DAY_PARTS = module + 'SET_DAY_PARTS'
export const SET_QUICK_ADD_ATTRIBUTES = module + 'SET_QUICK_ADD_ATTRIBUTES'
export const SET_DATE_RANGE = module + 'SET_DATE_RANGE'



// WEBPACK FOOTER //
// ./src/app/store/modules/applicationResources/constants.js